import React from 'react';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import utc from 'dayjs/plugin/utc';

dayjs.extend(isSameOrBefore);
dayjs.extend(utc);

// fromDate and toDate must be of type dayjs
const DateSelector = ({ fromDate, toDate, selectedDate, onSelectDate }) => {
  const days = [];
  let current = fromDate;

  while (current.isSameOrBefore(toDate, 'day')) {
    days.push(current);
    current = current.add(1, 'day');
  }

  const handleClick = (date) => {
    // if the clicked date is salready selected, we deselect it (null)
    if (selectedDate && dayjs.utc(selectedDate).isSame(date, 'day')) {
      onSelectDate(null);
    } else {
      onSelectDate(date);
    }
  };

  return (
    <div className="d-flex text-center my-3" style={{ height: '70px' }}>
      {days.map((date, index) => {
        const isSelected = selectedDate && dayjs.utc(selectedDate).isSame(date, 'day');

        return (
          <div
            key={index}
            className={`themed-border clickable p-1 flex-grow-1 ${index !== days.length - 1 ? 'border-right-0' : ''} ${isSelected ? 'bg-primary text-white' : ''}`}
            data-date={date.format('YYYY-MM-DD')}
            onClick={() => handleClick(date)}
          >
            <p>{date.format('ddd')}</p>
            <h4>{date.format('D')}</h4>
          </div>
        );
      })}
    </div>
  );
};

export default DateSelector;
